<div class="modal-header">
  <h3 class="modal-title">
    Rechnung versenden
  </h3>
</div>

<div class="modal-body">
  Möchten Sie die Rechnung mit der Nummer {{ id }} versenden ?

  <div>&nbsp;</div>

  <div class="text-hide">E-Post Modal</div>

  @if (!active) {
    <div class="alert alert-danger">
      Rechnung kann nicht versendet werden, da keine Post Zugangsdaten hinterlegt sind.
    </div>
  }

  @if (lock && !done) {
    <div class="row">
      <div class="col-sm-3">Wird gesendet</div>
      <div class="col-sm-9">
        <div class="progress">
          <div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar"
            aria-valuenow="100" aria-valuemin="0" style="width: 100%">
            <span class="sr-only">Wird gesendet</span>
          </div>
        </div>
      </div>
    </div>
  }

  @if (done) {
    <h4 class="alert alert-success">
      @switch (successVal) {
        @case ('mail') {
          Rechnung wurde erfolgreich per E-Mail verschickt
        }
        @case ('post') {
          Rechnung wird per Post verschickt
        }
        @default {
          Rechnung wurde erfolgreich verschickt
        }
      }
    </h4>
  }

  @if (errorText !== null) {
    <div class="alert alert-danger">
      <h4>Beim Versenden ist ein Fehler aufgetreten!</h4>
      {{ errorText }}
    </div>
  }

</div>

<div class="modal-footer">
  @if (!done) {
    <button class="btn btn-danger pull-left" type="button" [disabled]="lock" (click)="dismiss()">
      Abbrechen
    </button>
  }

  @if (!done && active) {
    <button class="btn btn-success pull-right" type="button" [disabled]="lock" (click)="send()">
      Senden
    </button>
  }

  @if (done) {
    <button class="btn btn-success pull-right" type="button" (click)="dismiss()">
      Schließen
    </button>
  }
</div>
